import React from "react";
import { useSubscribeStores } from "../../stores/SubscribeStores";

export function SubscriptionTab() {
  const { currentTab, setTab } = useSubscribeStores((state) => ({
    currentTab: state.currentTab,
    setTab: state.setTab,
  }));

  return (
    <div className="flex justify-center mb-8">
      <div className="bg-[#2D3139] p-1 rounded-[30px] flex items-center min-w-[300px]">
        <button
          onClick={() => setTab("monthly")}
          className={`flex-1 py-3 px-6 rounded-[25px] text-[16px] font-bold transition-all ${
            currentTab === "monthly"
              ? "bg-[#7E57C2] text-white shadow-lg"
              : "text-[#ccc] hover:text-white"
          }`}
        >
          Monthly
        </button>
        <button
          onClick={() => setTab("yearly")}
          className={`flex-1 py-3 px-6 rounded-[25px] text-[16px] font-bold transition-all flex items-center justify-center gap-2 ${
            currentTab === "yearly"
              ? "bg-[#7E57C2] text-white shadow-lg"
              : "text-[#ccc] hover:text-white"
          }`}
        >
          Yearly
          <span className="bg-[#FF4D4D] !text-white text-[10px] px-2 py-0.5 rounded-full">
            -30%
          </span>
        </button>
      </div>
    </div>
  );
}
